
import { useState, useEffect } from "react"
import { Card } from "react-bootstrap" // Added Form import
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import timeGridPlugin from "@fullcalendar/timegrid"
import interactionPlugin from "@fullcalendar/interaction"
import Swal from "sweetalert2"
import KarmaCollectPayment from "../Panchkarma/Components/KarmaCollectPayment"
import CreateAppointmentModal from "../Panchkarma/Components/CreateAppointmentModal"
import Select from "react-select"
import avatar1 from "../../../../src/assets/images/placeholder.jpg";
const DashboardPanchkarma = () => {
  const [showCollectPaymentModal, setShowCollectPaymentModal] = useState(false)
  const [activeDropdown, setActiveDropdown] = useState(null)
  const [showCreateAppointmentModal, setShowCreateAppointmentModal] = useState(false)
  const [selectedDateForAppointment, setSelectedDateForAppointment] = useState("")
  const [selectedRoom, setSelectedRoom] = useState("All") // Room selection

  const todaysFollowUps = [
    {
      name: "Michael Johnson",
      date: "28 Sept 2025 , 10:00am",
      action: "Follow-up on reschedule",
      nextAction: "Call again on 10-Feb",
      handler: "Dr.Shyam",
      type: "offline",
      room: "Room 1",
    },
    {
      name: "Jane Smith",
      date: "28 Sept 2025 , 11:00am",
      action: "Lab report review",
      nextAction: "Check patient feedback",
      handler: "Dr.Vivek",
      type: "online",
      room: "Room 2",
    },
    {
      name: "Alice Brown",
      date: "28 Sept 2025 , 12:00pm",
      action: "Medication review",
      nextAction: "Schedule appointment",
      handler: "Dr.Ashok",
      type: "offline",
      room: "Room 3",
    },
    {
      name: "Ajay Johnson",
      date: "28 Sept 2025 , 1:00pm",
      action: "Follow-up on reschedule",
      nextAction: "Call again on 10-Feb",
      handler: "Dr.Shyam",
      type: "online",
      room: "Room 1",
    },
    {
      name: "Amir Smith",
      date: "28 Sept 2025 , 2:00pm",
      action: "Lab report review",
      nextAction: "Check patient feedback",
      handler: "Dr.Vivek",
      type: "offline",
      room: "Room 1",
    },

    {
      name: "Laura Green",
      date: "28 Sept 2025 , 3:00pm",
      action: "Panchkarma session",
      nextAction: "Next session",
      handler: "Dr.Vivek",
      type: "online",
      room: "Room 2",
    },
    {
      name: "James Black",
      date: "28 Sept 2025 , 4:00pm",
      action: "Review progress",
      nextAction: "Continue therapy",
      handler: "Dr.Ashok",
      type: "offline",
      room: "Room 3",
    },
  ]

  const tomorrowsFollowUps = [
    {
      name: "David Wilson",
      date: "27 Sept 2025 , 10:30am",
      action: "Routine checkup reminder",
      nextAction: "Confirm with patient",
      handler: "Dr.Mohan",
      type: "offline",
      room: "Room 1",
    },
    {
      name: "Emily Davis",
      date: "27 Sept 2025 , 11:30am",
      action: "Follow-up on test results",
      nextAction: "Call patient",
      handler: "Dr.Vivek",
      type: "online",
      room: "Room 1",
    },
    {
      name: "Chris Evans",
      date: "27 Sept 2025 , 12:30pm",
      action: "Vaccination reminder",
      nextAction: "Send reminder email",
      handler: "Dr.Ashok",
      type: "offline",
      room: "Room 1",
    },
    {
      name: "David Wilson",
      date: "27 Sept 2025 , 1:30pm",
      action: "Routine checkup reminder",
      nextAction: "Confirm with patient",
      handler: "Dr.Mohan",
      type: "online",
      room: "Room 1",
    },
    {
      name: "Emily Davis",
      date: "27 Sept 2025 , 2:30pm",
      action: "Follow-up on test results",
      nextAction: "Call patient",
      handler: "Dr.Vivek",
      type: "offline",
      room: "Room 1",
    },
    {
      name: "Chris Evans",
      date: "27 Sept 2025 , 3:30pm",
      action: "Vaccination reminder",
      nextAction: "Send reminder email",
      handler: "Dr.Ashok",
      type: "online",
      room: "Room 3",
    },
    {
      name: "David Wilson",
      date: "27 Sept 2025 , 4:30pm",
      action: "Routine checkup reminder",
      nextAction: "Confirm with patient",
      handler: "Dr.Mohan",
      type: "offline",
      room: "Room 1",
    },
    {
      name: "Emily Davis",
      date: "27 Sept 2025 , 5:30pm",
      action: "Follow-up on test results",
      nextAction: "Call patient",
      handler: "Dr.Vivek",
      type: "online",
      room: "Room 1",
    },
    {
      name: "David Wilson",
      date: "26 Sept 2025 , 10:30am",
      action: "Routine checkup reminder",
      nextAction: "Confirm with patient",
      handler: "Dr.Mohan",
      type: "offline",
      room: "Room 1",
    },
    {
      name: "Emily Davis",
      date: "26 Sept 2025 , 11:30am",
      action: "Follow-up on test results",
      nextAction: "Call patient",
      handler: "Dr.Vivek",
      type: "online",
      room: "Room 1",
    },
    {
      name: "Chris Evans",
      date: "26 Sept 2025 , 12:30pm",
      action: "Vaccination reminder",
      nextAction: "Send reminder email",
      handler: "Dr.Ashok",
      type: "offline",
      room: "Room 1",
    },
    {
      name: "David Wilson",
      date: "26 Sept 2025 , 1:30pm",
      action: "Routine checkup reminder",
      nextAction: "Confirm with patient",
      handler: "Dr.Mohan",
      type: "online",
      room: "Room 1",
    },
    {
      name: "Emily Davis",
      date: "26 Sept 2025 , 2:30pm",
      action: "Follow-up on test results",
      nextAction: "Call patient",
      handler: "Dr.Vivek",
      type: "offline",
      room: "Room 1",
    },
    {
      name: "Chris Evans",
      date: "26 Sept 2025 , 3:30pm",
      action: "Vaccination reminder",
      nextAction: "Send reminder email",
      handler: "Dr.Ashok",
      type: "online",
      room: "Room 3",
    },
    {
      name: "David Wilson",
      date: "26 Sept 2025 , 4:30pm",
      action: "Routine checkup reminder",
      nextAction: "Confirm with patient",
      handler: "Dr.Mohan",
      type: "offline",
      room: "Room 1",
    },
    {
      name: "Emily Davis",
      date: "26 Sept 2025 , 5:30pm",
      action: "Follow-up on test results",
      nextAction: "Call patient",
      handler: "Dr.Vivek",
      type: "online",
      room: "Room 1",
    },
    {
      name: "Chris Evans",
      date: "26 Sept 2025 , 6:30pm",
      action: "Vaccination reminder",
      nextAction: "Send reminder email",
      handler: "Dr.Ashok",
      type: "offline",
      room: "Room 3",
    },
  ]

  const upcomingFollowUps = [
    {
      name: "Rahul Mehta",
      date: "27 Sept 2025 , 6:30pm",
      action: "Missed appointment reminder",
      nextAction: "No response, try again",
      handler: "Dr.Mohan",
      type: "online",
      room: "Room 1",
    },

    {
      name: "Ava White",
      date: "26 Oct 2025 , 3:30pm",
      action: "Initial Consultation",
      nextAction: "Treatment plan",
      handler: "Dr.Mohan",
      type: "online",
      room: "Room 1",
    },
  ]

  const [followUps, setFollowUps] = useState({
    today: [...todaysFollowUps],
    tomorrow: [...tomorrowsFollowUps],
    upcoming: [...upcomingFollowUps],
  })


  // Convert "10:30am" or "10:30 am" → "HH:mm:ss"
  const convertTime = (timeStr) => {
    const match = timeStr.match(/(\d+):(\d+)\s*(am|pm)/i)
    if (!match) return "00:00:00"

    let [, hours, minutes, period] = match
    let hour = parseInt(hours, 10)

    if (period.toLowerCase() === "pm" && hour !== 12) {
      hour += 12
    } else if (period.toLowerCase() === "am" && hour === 12) {
      hour = 0
    }

    return `${hour.toString().padStart(2, "0")}:${minutes}:00`
  }

  // Parse "28 Sept 2025 , 10:00am"
  const parsePatientDate = (dateStr) => {
    try {
      const cleanDateStr = dateStr.replace(/,/g, "").trim() // "28 Sept 2025 10:00am"
      const parts = cleanDateStr.split(" ")

      if (parts.length >= 4) {
        const day = parts[0].padStart(2, "0")
        const month = parts[1]
        const year = parts[2]
        const timeStr = parts.slice(3).join(" ") // works with "10:30 am" and "10:30am"

        const monthMap = {
          Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06",
          Jul: "07", Aug: "08", Sep: "09", Sept: "09", Oct: "10", Nov: "11", Dec: "12",
        }
        const monthNum = monthMap[month] || "01"

        return new Date(`${year}-${monthNum}-${day}T${convertTime(timeStr)}`)
      }

      return new Date()
    } catch (err) {
      console.error("Date parsing error:", err, dateStr)
      return new Date()
    }
  }


  const generateCalendarEvents = () => {
    const events = []

    const filteredToday = followUps.today.filter((patient) => !selectedRoom || selectedRoom === "All" || patient.room === selectedRoom)
    const filteredTomorrow = followUps.tomorrow.filter((patient) => !selectedRoom || selectedRoom === "All" || patient.room === selectedRoom)
    const filteredUpcoming = followUps.upcoming.filter((patient) => !selectedRoom || selectedRoom === "All" || patient.room === selectedRoom)

    filteredToday.forEach((patient, index) => {
      const eventDate = parsePatientDate(patient.date)
      events.push({
        id: `today-${index}`,
        title: `${patient.name}\n${patient.handler} (${patient.room})`,
        start: eventDate,
        end: eventDate,
        classNames: patient.type === "offline" ? ["bg-primary"] : ["bg-success"],
        extendedProps: {
          patient: patient,
          type: "today",
        },
      })
    })

    filteredTomorrow.forEach((patient, index) => {
      const eventDate = parsePatientDate(patient.date)
      events.push({
        id: `tomorrow-${index}`,
        title: `${patient.name}\n${patient.handler} (${patient.room})`,
        start: eventDate,
        end: eventDate,
        classNames: patient.type === "offline" ? ["bg-primary"] : ["bg-success"],
        extendedProps: {
          patient: patient,
          type: "tomorrow",
        },
      })
    })

    filteredUpcoming.forEach((patient, index) => {
      const eventDate = parsePatientDate(patient.date)
      events.push({
        id: `upcoming-${index}`,
        title: `${patient.name}\n${patient.handler} (${patient.room})`,
        start: eventDate,
        end: eventDate,
        classNames: patient.type === "online" ? ["bg-success"] : ["bg-secondary"],
        extendedProps: {
          patient: patient,
          type: "upcoming",
        },
      })
    })

    return events
  }

  const [calendarEvents, setCalendarEvents] = useState(generateCalendarEvents())

  useEffect(() => {
    setCalendarEvents(generateCalendarEvents())
  }, [selectedRoom, followUps])

  const handleChangeDoctor = (eventId, newDoctor) => {
    const [type, index] = eventId.split("-")
    setFollowUps((prev) => {
      const updatedList = [...prev[type]]
      updatedList[index] = { ...updatedList[index], handler: newDoctor }
      return { ...prev, [type]: updatedList }
    })
    setCalendarEvents(generateCalendarEvents())
    setActiveDropdown(null)
  }

  const toggleDropdown = (eventId) => {
    setActiveDropdown((prev) => (prev === eventId ? null : eventId))
  }
  const handleEventClick = (eventClick) => {
    const event = eventClick.event;
    const patient = event.extendedProps.patient;
    const eventId = event.id;

    Swal.fire({

      html: `
        <div style="text-align: left;">
          <!-- Profile Row with Actions -->
          <div class="d-flex justify-content-between align-items-center mb-3">
            <!-- Left: Profile -->
            <div class="d-flex align-items-center">
              <img src="${patient.profilePic || avatar1}" 
                   alt="Profile Picture"
                   style="width: 60px; height: 60px; border-radius: 50%; object-fit: cover; margin-right: 15px;" />
              <div>
                <h6 class="mb-1 fs-3" >${patient.name}</h6>
              
              </div>
            </div>
  
            <!-- Right: Actions -->
            <div class="d-flex gap-3 align-items-center">
              <img src="/icons8-call-102.png" alt="Call Icon" 
                   style="width: 24px; height: 24px; cursor: pointer;" id="callBtn"/>
              <i class="fa fa-eye fs-18" style="cursor: pointer;" id="viewBtn" aria-hidden="true"></i>
            </div>
          </div>
  
          <!-- Patient Details -->
          <p class="mb-1"><strong>Doctor:</strong> ${patient.handler}</p>
          <p class="mb-1"><strong>Date:</strong> ${patient.date}</p>
          <p class="mb-1"><strong>Type:</strong> ${patient.type === "offline" ? "Offline" : "Online"}</p>
  
          <!-- Room Dropdown -->
      <div class="d-flex align-items-center justify-content-between mb-2" style="gap: 20px;">
  
  <!-- Room Dropdown -->
  <div class="d-flex align-items-center" style="gap: 6px; flex: 1;">
    <label for="roomSelect" class="mb-0">
      <strong>Room:</strong>
    </label>
    <select id="roomSelect" class="form-select" style="height: 38px; max-width: 160px;">
      <option value="Room 1" ${patient.room === "Room 1" ? "selected" : ""}>Room 1</option>
      <option value="Room 2" ${patient.room === "Room 2" ? "selected" : ""}>Room 2</option>
    </select>
  </div>

  <!-- Therapist Dropdown -->
  <div class="d-flex align-items-center" style="gap: 6px; flex: 1;">
    <label for="doctorSelect" class="mb-0">
      <strong>Therapist:</strong>
    </label>
    <select id="doctorSelect" class="form-select" style="height: 38px; max-width: 160px;">
      <option value="Dr.Shyam" ${patient.handler === "Dr.Shyam" ? "selected" : ""}>Dr.Shyam</option>
      <option value="Dr.Vivek" ${patient.handler === "Dr.Vivek" ? "selected" : ""}>Dr.Vivek</option>
      <option value="Dr.Ashok" ${patient.handler === "Dr.Ashok" ? "selected" : ""}>Dr.Ashok</option>
      <option value="Dr.Mohan" ${patient.handler === "Dr.Mohan" ? "selected" : ""}>Dr.Mohan</option>
    </select>
  </div>

</div>

        </div>
      `,
      width: "600px",

      // Buttons
      showConfirmButton: true,
      confirmButtonText: "Close",
      showDenyButton: true,
      denyButtonText: "Collect Payment",

      customClass: {
        actions: "d-flex justify-content-center gap-3",
        confirmButton: "btn btn-sm btn-danger",
        denyButton: "btn btn-sm btn-info",
      },
      buttonsStyling: false,

      didOpen: () => {
        // Therapist change
        const doctorSelect = document.getElementById("doctorSelect");
        if (doctorSelect) {
          doctorSelect.addEventListener("change", (e) => {
            handleChangeDoctor(eventId, e.target.value);
          });
        }

        // Room change
        const roomSelect = document.getElementById("roomSelect");
        if (roomSelect) {
          roomSelect.addEventListener("change", (e) => {
            handleChangeRoom(eventId, e.target.value);
          });
        }

        // Call action
        const callBtn = document.getElementById("callBtn");
        if (callBtn) {
          callBtn.addEventListener("click", () => {
            console.log(`📞 Making call to ${patient.name}`);
          });
        }

        // View details action
        const viewBtn = document.getElementById("viewBtn");
        if (viewBtn) {
          viewBtn.addEventListener("click", () => {
            window.location.href = "/panchkarma-view-details";
          });
        }
      },
    }).then((result) => {
      if (result.isDenied) {
        setShowCollectPaymentModal(true);
      }
    });
  };


  // handle event drag-drop
  const handleEventDrop = (info) => {
    const { event } = info;
    const newStart = info.event.start;
    const oldStart = info.oldEvent.start;

    const daysDiff = Math.floor((newStart - oldStart) / (1000 * 60 * 60 * 24));
    if (!daysDiff) return;

    setCalendarEvents((prevEvents) =>
      prevEvents.map((e) => {
        const eStart = new Date(e.start);
        if (eStart >= oldStart) {
          const newEventStart = new Date(eStart);
          newEventStart.setDate(newEventStart.getDate() + daysDiff);

          const newEventEnd = new Date(e.end);
          newEventEnd.setDate(newEventEnd.getDate() + daysDiff);

          return { ...e, start: newEventStart, end: newEventEnd };
        }
        return e;
      })
    );

    Swal.fire({
      title: "Appointment Rescheduled",
      text: `This and subsequent events moved by ${daysDiff} day(s).`,
      icon: "info",
      didOpen: () => {
        // ✅ Inline z-index fix
        const swalContainer = document.querySelector(".swal2-container");
        if (swalContainer) {
          swalContainer.style.zIndex = "20000";
        }
        const swalPopup = document.querySelector(".swal2-popup");
        if (swalPopup) {
          swalPopup.style.zIndex = "20001";
        }
      }
    });

  };
  // const handleEventDrop = (info) => {
  //   const { event } = info;
  //   const newStart = info.event.start;
  //   const oldStart = info.oldEvent.start;

  //   const daysDiff = Math.floor((newStart - oldStart) / (1000 * 60 * 60 * 24));
  //   if (!daysDiff) return;

  //   setCalendarEvents((prevEvents) =>
  //     prevEvents.map((e) => {
  //       const eStart = new Date(e.start);
  //       if (eStart >= oldStart) {
  //         const newEventStart = new Date(eStart);
  //         newEventStart.setDate(newEventStart.getDate() + daysDiff);

  //         const newEventEnd = new Date(e.end);
  //         newEventEnd.setDate(newEventEnd.getDate() + daysDiff);

  //         return { ...e, start: newEventStart, end: newEventEnd };
  //       }
  //       return e;
  //     })
  //   );

  //   Swal.fire({
  //     title: "Appointment Rescheduled",
  //     text: `This and subsequent events moved by ${daysDiff} day(s).`,
  //     icon: "info",
  //     didOpen: () => {
  //       // ✅ Inline z-index fix
  //       const swalContainer = document.querySelector(".swal2-container");
  //       if (swalContainer) {
  //         swalContainer.style.zIndex = "20000";
  //       }
  //       const swalPopup = document.querySelector(".swal2-popup");
  //       if (swalPopup) {
  //         swalPopup.style.zIndex = "20001";
  //       }
  //     }
  //   });

  // };

  // handle event resize
  const handleEventResize = (info) => {
    const { event } = info;
    console.log("Event resized →", event.title, "Start:", event.start, "End:", event.end);
  };


  const formatDateDDMMYYYY = (isoDateStr) => {
    const date = new Date(isoDateStr)
    const day = String(date.getDate()).padStart(2, "0")
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const year = date.getFullYear()
    return `${day}-${month}-${year}`
  }




  const handleDateClick = (dateClick) => {
    const clickedDate = dateClick.dateStr
    const today = new Date().toISOString().split("T")[0]

    const isPastDate = new Date(clickedDate) < new Date(today)
    const isFutureDate = new Date(clickedDate) > new Date(today) // ✅ new check

    const eventsOnDate = calendarEvents.filter((event) => {
      const eventDate = event.start.toISOString().split("T")[0]
      return eventDate === clickedDate
    })

    const formattedDate = formatDateDDMMYYYY(clickedDate)

    // ✅ If future date + no events → open create modal directly
    if (isFutureDate && eventsOnDate.length === 0) {
      setSelectedDateForAppointment(clickedDate)
      setShowCreateAppointmentModal(true)
      return
    }

    if (eventsOnDate.length === 0) {
      Swal.fire({
        title: "No Appointments",
        text: `No appointments scheduled for ${formattedDate}.`,
        icon: "info",
        showCancelButton: !isPastDate,
        cancelButtonText: "Create Appointment",
        didOpen: () => {
          if (!isPastDate) {
            const cancelButton = Swal.getCancelButton()
            if (cancelButton) {
              cancelButton.onclick = () => {
                setSelectedDateForAppointment(clickedDate)
                setShowCreateAppointmentModal(true)
                Swal.close()
              }
            }
          }
        },
      })
      return
    }

    const patientsHtml = eventsOnDate
      .map((event) => {
        const patient = event.extendedProps.patient
        return `
          <div style="border: 1px solid #ddd; padding: 10px; margin: 5px 0; border-radius: 5px;">
            <strong>${patient.name}</strong> - ${patient.handler}<br>
            <small>${patient.date} - Room: ${patient.room}</small><br>
            <em>${patient.action}</em>
          </div>
        `
      })
      .join("")

    Swal.fire({
      title: `Appointments for ${formattedDate}`,
      html: patientsHtml,
      confirmButtonText: "Close",
      width: "600px",
      showCancelButton: !isPastDate,
      cancelButtonText: "Create New Appointment",
      didOpen: () => {
        if (!isPastDate) {
          const cancelButton = Swal.getCancelButton()
          if (cancelButton) {
            cancelButton.onclick = () => {
              setSelectedDateForAppointment(clickedDate)
              setShowCreateAppointmentModal(true)
              Swal.close()
            }
          }
        }
      },
    })
  }

  const handleSaveNewAppointment = (newAppointment) => {
    const newEvent = {
      name: newAppointment.patient,
      date: `${newAppointment.date} , ${newAppointment.timeSlot}`,
      action: "New Appointment",
      nextAction: "Follow-up",
      handler: newAppointment.therapist,
      type: newAppointment.mode,
      room: newAppointment.room,
    }

    setFollowUps((prev) => {
      const updatedUpcoming = [...prev.upcoming, newEvent]
      return { ...prev, upcoming: updatedUpcoming }
    })
    setShowCreateAppointmentModal(false)
  }
  const roomOptions = [
    { value: "All", label: "All " },
    { value: "Room 1", label: "Room 1" },
    { value: "Room 2", label: "Room 2" },

  ]
  const doctorOptions = [
    { value: "Dr.Shyam", label: "Dr.Shyam" },
    { value: "Dr.Vivek", label: "Dr.Vivek" },
    { value: "Dr.Ashok", label: "Dr.Ashok" },
    { value: "Dr.Mohan", label: "Dr.Mohan" },
  ]

  const renderEventContent = (eventInfo) => {
    const patient = eventInfo.event.extendedProps.patient
    return (
      <div
        className={eventInfo.event.classNames.join(" ")}
        style={{
          color: "white",
          padding: "8px",
          borderRadius: "4px",
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          boxSizing: "border-box",
          textAlign: "center",
          fontSize: "0.9em",
        }}
      >
        <div style={{ fontWeight: "bold" }}>{patient.name}</div>
        <div style={{ fontSize: "0.8em" }}>{patient.handler}</div>
        <div style={{ fontSize: "0.7em" }}>{patient.room}</div>
      </div>
    )
  }

  return (
    <div>
      <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
        <div className="me-auto d-none d-lg-block">
          <h3 className="text-black font-w600">Welcome to Rohati Ayurved!</h3>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-4 col-xxl-6 col-sm-6">
          <div className="card gradient-bx text-white bg-danger rounded">
            <div className="card-body">
              <div className="media align-items-center">
                <div className="media-body">
                  <p className="mb-1">Panchkarma Completed Patients</p>
                  <div className="d-flex flex-wrap">
                    <h2 className="fs-40 font-w600 text-white mb-0 me-3">783</h2>
                    <div>
                      <svg width={28} height={19} viewBox="0 0 28 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                          <linearGradient
                            id="paint0_linear4"
                            x1="13.7187"
                            y1="3.0625"
                            x2="14.7499"
                            y2="17.5"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="white" stopOpacity="0.73" offset="0.1" />
                            <stop offset={1} stopColor="white" stopOpacity={0} />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
                <span className="border rounded-circle p-4">
                  <svg width={34} height={34} viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M23.6667 0.333311C21.1963 0.264777 18.7993 1.17744 17 2.87164C15.2008 1.17744 12.8038 0.264777 10.3334 0.333311C8.9341 0.337244 7.55292 0.649469 6.28803 1.24778C5.02315 1.84608 3.90564 2.71577 3.01502 3.79498C-0.039984 7.45998 -0.261651 13.3333 1.19668 17.5966C1.21002 17.6266 1.22002 17.6566 1.23335 17.6866C3.91168 25.3333 15.2717 33.6666 17 33.6666C18.6983 33.6666 30.025 25.5166 32.7667 17.6866C32.78 17.6566 32.79 17.6266 32.8034 17.5966C34.2417 13.4016 34.0867 7.51498 30.985 3.79498C30.0944 2.71577 28.9769 1.84608 27.712 1.24778C26.4471 0.649469 25.0659 0.337244 23.6667 0.333311ZM17 30.03C14.6817 28.5233 8.23168 24 5.30335 18.6666H12C12.2743 18.6667 12.5444 18.599 12.7863 18.4696C13.0282 18.3403 13.2344 18.1532 13.3867 17.925L14.83 15.7583L17.0867 22.525C17.1854 22.8207 17.3651 23.0829 17.6054 23.2816C17.8456 23.4803 18.1368 23.6076 18.4458 23.6491C18.7548 23.6906 19.0693 23.6446 19.3535 23.5163C19.6376 23.388 19.8801 23.1825 20.0533 22.9233L22.8917 18.6666H28.6984C25.7684 24 19.3183 28.5233 17 30.03ZM29.975 15.3333H22C21.7257 15.3333 21.4556 15.4009 21.2137 15.5303C20.9718 15.6597 20.7656 15.8468 20.6133 16.075L19.17 18.2416L16.9133 11.475C16.8146 11.1792 16.6349 10.9171 16.3947 10.7184C16.1544 10.5196 15.8632 10.3923 15.5542 10.3508C15.2452 10.3093 14.9307 10.3553 14.6466 10.4837C14.3624 10.612 14.1199 10.8174 13.9467 11.0766L11.1084 15.3333H4.02502C3.35835 12.1816 3.50502 8.41164 5.57668 5.92831C6.151 5.22081 6.87614 4.65057 7.69911 4.25927C8.52209 3.86797 9.42209 3.6655 10.3334 3.66664C15.445 3.66664 14.9117 7.16664 16.9817 7.18664H17C19.0733 7.18664 18.5483 3.66664 23.6667 3.66664C24.5785 3.665 25.4792 3.86723 26.3027 4.25855C27.1263 4.64987 27.852 5.22037 28.4267 5.92831C30.4867 8.40331 30.6467 12.1666 29.975 15.3333Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-xxl-6 col-sm-6">
          <div className="card gradient-bx text-white bg-success rounded">
            <div className="card-body">
              <div className="media align-items-center">
                <div className="media-body">
                  <p className="mb-1">Panchkarma Ongoing Patients</p>
                  <div className="d-flex flex-wrap">
                    <h2 className="fs-40 font-w600 text-white mb-0 me-3">76</h2>
                    <div>
                      <svg width={28} height={19} viewBox="0 0 28 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                          <linearGradient
                            id="paint0_linear1"
                            x1="13.7188"
                            y1="3.0625"
                            x2="12.6875"
                            y2="17.5"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="white" stopOpacity="0.73" offset="0.1" />
                            <stop offset={1} stopColor="white" stopOpacity={0} />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
                <span className="border rounded-circle p-4">
                  <svg width={34} height={34} viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M37.3333 15.6666C37.3383 14.7488 37.0906 13.8473 36.6174 13.061C36.1441 12.2746 35.4635 11.6336 34.6501 11.2084C33.8368 10.7831 32.9221 10.5899 32.0062 10.65C31.0904 10.7101 30.2087 11.021 29.4579 11.5489C28.707 12.0767 28.1159 12.8011 27.7494 13.6425C27.3829 14.484 27.255 15.4101 27.3799 16.3194C27.5047 17.2287 27.8774 18.086 28.4572 18.7976C29.0369 19.5091 29.8013 20.0473 30.6667 20.3533V25.6666C30.6667 27.8768 29.7887 29.9964 28.2259 31.5592C26.6631 33.122 24.5435 34 22.3333 34C20.1232 34 18.0036 33.122 16.4408 31.5592C14.878 29.9964 14 27.8768 14 25.6666V23.8666C16.7735 23.4642 19.3097 22.0777 21.1456 19.9603C22.9815 17.8429 23.9946 15.1358 24 12.3333V2.33329C24 1.89127 23.8244 1.46734 23.5118 1.15478C23.1993 0.842221 22.7754 0.666626 22.3333 0.666626H17.3333C16.8913 0.666626 16.4674 0.842221 16.1548 1.15478C15.8423 1.46734 15.6667 1.89127 15.6667 2.33329C15.6667 2.77532 15.8423 3.19924 16.1548 3.5118C16.4674 3.82436 16.8913 3.99996 17.3333 3.99996H20.6667V12.3333C20.6667 14.5434 19.7887 16.663 18.2259 18.2258C16.6631 19.7887 14.5435 20.6666 12.3333 20.6666C10.1232 20.6666 8.00358 19.7887 6.44077 18.2258C4.87797 16.663 4 14.5434 4 12.3333V3.99996H7.33333C7.77536 3.99996 8.19928 3.82436 8.51184 3.5118C8.8244 3.19924 9 2.77532 9 2.33329C9 1.89127 8.8244 1.46734 8.51184 1.15478C8.19928 0.842221 7.77536 0.666626 7.33333 0.666626H2.33333C1.8913 0.666626 1.46738 0.842221 1.15482 1.15478C0.842259 1.46734 0.666664 1.89127 0.666664 2.33329V12.3333C0.672024 15.1358 1.68515 17.8429 3.52106 19.9603C5.35697 22.0777 7.8932 23.4642 10.6667 23.8666V25.6666C10.6667 28.7608 11.8958 31.7283 14.0837 33.9162C16.2717 36.1041 19.2391 37.3333 22.3333 37.3333C25.4275 37.3333 28.395 36.1041 30.5829 33.9162C32.7708 31.7283 34 28.7608 34 25.6666V20.3533C34.9723 20.0131 35.8151 19.3797 36.4122 18.5402C37.0092 17.7008 37.3311 16.6967 37.3333 15.6666Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-xxl-6 col-sm-6">
          <div className="card gradient-bx text-white bg-info rounded">
            <div className="card-body">
              <div className="media align-items-center">
                <div className="media-body">
                  <p className="mb-1">Panchkarma Pending Patients</p>
                  <div className="d-flex flex-wrap">
                    <h2 className="fs-40 font-w600 text-white mb-0 me-3">76</h2>
                    <div>
                      <svg width={28} height={19} viewBox="0 0 28 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                          <linearGradient
                            id="paint0_linear2"
                            x1="13.7188"
                            y1="3.0625"
                            x2="12.6875"
                            y2="17.5"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="white" stopOpacity="0.73" offset="0.1" />
                            <stop offset={1} stopColor="white" stopOpacity={0} />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
                <span className="border rounded-circle p-4">
                  <svg width={34} height={34} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0)">
                      <path
                        d="M35 5H33.3333C33.3333 3.67392 32.8065 2.40215 31.8689 1.46447C30.9312 0.526784 29.6594 0 28.3333 0C27.0072 0 25.7355 0.526784 24.7978 1.46447C23.8601 2.40215 23.3333 3.67392 23.3333 5H16.6667C16.6667 3.67392 16.1399 2.40215 15.2022 1.46447C14.2645 0.526784 12.9927 7.45058e-08 11.6667 7.45058e-08C10.3406 7.45058e-08 9.06881 0.526784 8.13113 1.46447C7.19345 2.40215 6.66667 3.67392 6.66667 5H5C3.67392 5 2.40215 5.52678 1.46447 6.46447C0.526784 7.40215 0 8.67392 0 10L0 35C0 36.3261 0.526784 37.5979 1.46447 38.5355C2.40215 39.4732 3.67392 40 5 40H35C36.3261 40 37.5979 39.4732 38.5355 38.5355C39.4732 37.5979 40 36.3261 40 35V10C40 8.67392 39.4732 7.40215 38.5355 6.46447C37.5979 5.52678 36.3261 5 35 5ZM5 8.33333H6.66667C6.66667 9.65942 7.19345 10.9312 8.13113 11.8689C9.06881 12.8065 10.3406 13.3333 11.6667 13.3333C12.1087 13.3333 12.5326 13.1577 12.8452 12.8452C13.1577 12.5326 13.3333 12.1087 13.3333 11.6667C13.3333 11.2246 13.1577 10.8007 12.8452 10.4882C12.5326 10.1756 12.1087 10 11.6667 10C11.2246 10 10.8007 9.8244 10.4882 9.51184C10.1756 9.19928 10 8.77536 10 8.33333V5C10 4.55797 10.1756 4.13405 10.4882 3.82149C10.8007 3.50893 11.2246 3.33333 11.6667 3.33333C12.1087 3.33333 12.5326 3.50893 12.8452 3.82149C13.1577 4.13405 13.3333 4.55797 13.3333 5V6.66667C13.3333 7.10869 13.5089 7.53262 13.8215 7.84518C14.134 8.15774 14.558 8.33333 15 8.33333H23.3333C23.3333 9.65942 23.8601 10.9312 24.7978 11.8689C25.7355 12.8065 27.0072 13.3333 28.3333 13.3333C28.7754 13.3333 29.1993 13.1577 29.5118 12.8452C29.8244 12.5326 30 12.1087 30 11.6667C30 11.2246 29.8244 10.8007 29.5118 10.4882C29.1993 10.1756 28.7754 10 28.3333 10C27.8913 10 27.4674 9.8244 27.1548 9.51184C26.8423 9.19928 26.6667 8.77536 26.6667 8.33333V5C26.6667 4.55797 26.8423 4.13405 27.1548 3.82149C27.4674 3.50893 27.8913 3.33333 28.3333 3.33333C28.7754 3.33333 29.1993 3.50893 29.5118 3.82149C29.8244 4.13405 30 4.55797 30 5V6.66667C30 7.10869 30.1756 7.53262 30.4882 7.84518C30.8007 8.15774 31.2246 8.33333 31.6667 8.33333H35C35.442 8.33333 35.866 8.50893 36.1785 8.82149C36.4911 9.13405 36.6667 9.55797 36.6667 10V16.6666H3.33333V10C3.33333 9.55797 3.50893 9.13405 3.82149 8.82149C4.13405 8.50893 4.55797 8.33333 5 8.33333ZM35 36.6667H5C4.55797 36.6667 4.13405 36.4911 3.82149 36.1785C3.50893 35.866 3.33333 35.442 3.33333 35V20H36.6667V35C36.6667 35.442 36.4911 35.866 36.1785 36.1785C35.866 36.4911 35.442 36.6667 35 36.6667Z"
                        fill="white"
                      />
                      <path
                        d="M20 26.6667C20.9205 26.6667 21.6667 25.9205 21.6667 25C21.6667 24.0795 20.9205 23.3333 20 23.3333C19.0795 23.3333 18.3333 24.0795 18.3333 25C18.3333 25.9205 19.0795 26.6667 20 26.6667Z"
                        fill="white"
                      />
                      <path
                        d="M30 26.6667C30.9205 26.6667 31.6667 25.9205 31.6667 25C31.6667 24.0795 30.9205 23.3333 30 23.3333C29.0796 23.3333 28.3334 24.0795 28.3334 25C28.3334 25.9205 29.0796 26.6667 30 26.6667Z"
                        fill="white"
                      />
                      <path
                        d="M9.99995 26.6667C10.9204 26.6667 11.6666 25.9205 11.6666 25C11.6666 24.0795 10.9204 23.3333 9.99995 23.3333C9.07947 23.3333 8.33328 24.0795 8.33328 25C8.33328 25.9205 9.07947 26.6667 9.99995 26.6667Z"
                        fill="white"
                      />
                      <path
                        d="M20 33.3334C20.9205 33.3334 21.6667 32.5872 21.6667 31.6667C21.6667 30.7462 20.9205 30 20 30C19.0795 30 18.3333 30.7462 18.3333 31.6667C18.3333 32.5872 19.0795 33.3334 20 33.3334Z"
                        fill="white"
                      />
                      <path
                        d="M30 33.3334C30.9205 33.3334 31.6667 32.5872 31.6667 31.6667C31.6667 30.7462 30.9205 30 30 30C29.0796 30 28.3334 30.7462 28.3334 31.6667C28.3334 32.5872 29.0796 33.3334 30 33.3334Z"
                        fill="white"
                      />
                      <path
                        d="M9.99995 33.3334C10.9204 33.3334 11.6666 32.5872 11.6666 31.6667C11.6666 30.7462 10.9204 30 9.99995 30C9.07947 30 8.33328 31.6667 8.33328 31.6667C8.33328 32.5872 9.07947 33.3334 9.99995 33.3334Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0">
                        <rect width={40} height={40} fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <Card>
            <Card.Header className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
              <Card.Title className="mb-2 mb-md-0">Patient Appointments Calendar</Card.Title>

              <div className="d-flex flex-wrap gap-3 justify-content-md-end align-items-center">

                {/* Room Filter */}
                <div className="d-flex align-items-center">
                  <span className="me-2 mb-0">Room:</span>
                  <select
                    className="form-select"
                    style={{ width: "180px", height: "40px" }}

                    value={selectedRoom}
                    onChange={(e) => setSelectedRoom(e.target.value)}
                  >
                    <option value="All">All</option>
                    <option value="Room 1">Room 1</option>
                    <option value="Room 2">Room 2</option>

                  </select>
                </div>

                {/* Legends */}
                <span className="d-flex align-items-center">
                  <span className="badge bg-primary me-1">●</span> Offline 
                </span>
                <span className="d-flex align-items-center">
                  <span className="badge bg-success me-1">●</span> Online 
                </span>
              </div>
            </Card.Header>


            <Card.Body>

              <div className="demo-app-calendar" id="mycalendartest">
                <FullCalendar
                  initialView="timeGridWeek"   // ✅ default week view
                  headerToolbar={{
                    left: "prev,next today",
                    center: "title",
                    right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
                  }}
                  plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                  events={calendarEvents}
                  editable={true}
                  droppable={true}
                  eventDrop={handleEventDrop}
                  eventResize={handleEventResize}
                  eventClick={handleEventClick}
                  dateClick={handleDateClick}
                  eventContent={renderEventContent}
                  height="auto"
                  dayMaxEvents={9}
                  moreLinkClick="popover"
                />

              </div>

            </Card.Body>
          </Card>
        </div>
      </div>

      <KarmaCollectPayment
        show={showCollectPaymentModal}
        handleClose={() => setShowCollectPaymentModal(false)}
        onCollectPayment={(data) => console.log("Collecting Payment:", data)}
        onSendPaymentLink={(data) => console.log("Sending Link:", data)}
      />

      <CreateAppointmentModal
        show={showCreateAppointmentModal}
        handleClose={() => setShowCreateAppointmentModal(false)}
        handleSaveAppointment={handleSaveNewAppointment}
        selectedDate={selectedDateForAppointment}
      />
    </div>
  )
}

export default DashboardPanchkarma;